import { Customer } from "@core/models/customer.model";
import { Preference } from "@core/models/preference";

export class UserProfile {
	id!: string;
	email!: string;
	// Will: seems to be used only to change password. Not yet implemented. Remove the value immediately after BE API calling.
	password: string | undefined; // TODO should this be here? It probably should not be held in memory (if the profile object was used to update the password)
	firstName: string | undefined;
	lastName: string | undefined;
	address1: string | undefined;
	address2: string | undefined;
	city: string | undefined;
	state: string | undefined;
	country: string | undefined;
	zipcode: string | undefined;
	phone: string | undefined;
	customers: Customer[] | undefined;
	preferences: Preference[] | undefined;
}
